module.exports = __webpack_public_path__ + "img/vi.120662fc.png";